import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import LZString from 'lz-string';
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import WInput from "@/components/form/w-input.vue";
import axios from "axios";
import { alertError } from "@/util/dialog";
import Loader from "@/components/loader/Loader.vue";
import LightButton from "@/components/buttons/LightButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import delay from "delay";
import { WeetEventName } from "@/weet/weetEvent";
import { onGenericWeetEditingMessage, updateWeetRecorded } from "@/util/weetMessageUtil";
import { v4 as uuidv4 } from 'uuid';
import { WeetInitiator } from "@/models/weetInitiator/WeetInitiator";
import { DocumentDescriptionModel } from "@/models/ai/documentDescription.model";
import { timestampToSeconds } from "@/util/timestampUtil";
import { DocumentType, DocumentWrapperModel } from "@/models/ai/documentWrapper.model";
import { getAllowedSlideTemplates, getVisualTemplateByKey } from "@/models/ai/aiVisualTemplate.model";
import { getSubChapterTypeConfig } from "@/models/ai/aiSubChapterTypeConfig.model";
import { SubChapterType } from "@/models/ai/aiSubChapter.model";
let AIChapterContentGenerator = class AIChapterContentGenerator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachGenerated", void 0);
    _defineProperty(this, "speachToMap", void 0);
    _defineProperty(this, "indexLecon", void 0);
    _defineProperty(this, "indexChapter", void 0);
    _defineProperty(this, "weetEndpoint", void 0);
    _defineProperty(this, "aiFiles", []);
    _defineProperty(this, "chapitreIdMap", void 0);
    _defineProperty(this, "autoMode", void 0);
    _defineProperty(this, "urlEditing", void 0);
    _defineProperty(this, "loadingInterface", false);
    _defineProperty(this, "chapter", null);
    _defineProperty(this, "weetID", "");
  }
  async mounted() {
    this.purgeExpiredWeetInitiator();
    this.loadingInterface = true;
    // get chapter with index
    this.chapter = this.getChapterToMap();
    // create the weetInitiator object
    const initID = uuidv4();
    this.createAndSaveWeetInitiator(initID);
    this.urlEditing = await axios.get('/api/v2/recorder/getUrlEditingForChapter/' + this.chapter.id).then(response => response.data);
    this.urlEditing += "&initID=" + initID;
    window.addEventListener('message', this.onMessageReceive);
    this.cleanWeetInitiatorWithDelay(initID);
  }
  onClose(weetID) {
    this.$emit('onClose', weetID);
    // send the close element
    window.removeEventListener("message", this.onMessageReceive);
  }
  async onMessageReceive(event) {
    if (this.chapter) {
      const weetEvent = onGenericWeetEditingMessage(event, this.weetEndpoint, this.chapter.id);
      if (weetEvent) {
        if (weetEvent.name === WeetEventName.SEND_WEET_ID) {
          this.weetID = weetEvent.data.weetID;
          if (weetEvent.data.modified) {
            try {
              await updateWeetRecorded(this.weetID, this.chapter.id, weetEvent.data.duration);
            } catch (error) {
              console.error("error on save weet", error);
              alertError(error.toString());
            }
          }
          this.onClose(this.weetID);
        }
      }
    }
  }
  async iFrameLoaded() {
    await delay(1500);
    this.loadingInterface = false;
  }
  async createAndSaveWeetInitiator(initID) {
    const listOfDocumentPage = this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter].documentPages;
    const documents = [];
    for (const aiDocumentPage of listOfDocumentPage) {
      let fileUsed = this.aiFiles.find(aiFile => {
        return aiFile.jobID === aiDocumentPage.jobID;
      });
      if (fileUsed?.data) {
        // fix old json compatibility
        if (!fileUsed.data.type) {
          // @ts-ignore
          const documentDescription = new DocumentDescriptionModel(fileUsed.data);
          fileUsed.data = new DocumentWrapperModel(DocumentType.DOCUMENT, documentDescription);
        }
        if (fileUsed.data.type === "DOCUMENT") {
          const docWrap = fileUsed.data.data;
          const pdfPage = docWrap.pages[aiDocumentPage.pageNumber - 1];
          pdfPage.documentName = docWrap.documentName;
          documents.push({
            type: 'PDF_PAGE',
            data: pdfPage
          });
        } else if (fileUsed.data.type === "VIDEO") {
          const docWrap = fileUsed.data.data;
          // add all videoChapters between timestampStart and timestampEnd
          const chaptersInRange = docWrap.videoChapters.filter(vChapter => {
            return timestampToSeconds(vChapter.timestampStart) >= timestampToSeconds(aiDocumentPage.timestampStart) && timestampToSeconds(vChapter.timestampEnd) <= timestampToSeconds(aiDocumentPage.timestampEnd);
          });
          for (const vChapter of chaptersInRange) {
            // enhance the chapter with the document name and video quality
            vChapter.documentName = docWrap.documentName;
            vChapter.videoQuality = docWrap.videoQuality;
            vChapter.soundQuality = docWrap.soundQuality;
            vChapter.fileID = docWrap.fileID;
            documents.push({
              type: 'VIDEO_SECTION',
              data: vChapter
            });
          }
        }
      }
    }
    const indexSubChapter = this.indexLecon + 1 + "-" + (this.indexChapter + 1);
    const currentSubChapter = this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter];
    // Resolve the per-type config. If the subchapter carries a previously
    // persisted hiddenPromptGeneration (Continue via AI), reuse it verbatim
    // so we honor exactly what was generated the first time — even if the
    // per-type config file has evolved since then.
    const subChapterType = currentSubChapter.type || SubChapterType.SLIDE;
    const typeConfig = getSubChapterTypeConfig(subChapterType);
    const tplKey = this.speachGenerated.generationOptions?.visualTemplate ?? null;
    const templateHiddenPrompt = getVisualTemplateByKey(tplKey)?.hiddenPrompt || null;
    let hiddenPrompt;
    if (currentSubChapter.hiddenPromptGeneration) {
      hiddenPrompt = currentSubChapter.hiddenPromptGeneration;
    } else {
      hiddenPrompt = `Generate a script **only** for sub-chapter index <subChapterSelected>${indexSubChapter}</subChapterSelected> ` + `titled "${currentSubChapter.title}" of the training module "${this.speachGenerated.title}".\n\n` + `<subChapterSubjects>\n`;
      if (currentSubChapter.subjects) {
        hiddenPrompt += `The script must cover ONLY the following subjects:\n` + currentSubChapter.subjects.map((subject, idx) => `${idx + 1}. ${subject}`).join('\n') + '\n' + `</subChapterSubjects>\n\n`;
      }
      hiddenPrompt += `<trainingModule>\n${JSON.stringify(this.speachGenerated, null, 2)}\n</trainingModule>\n\n` + `Instructions:\n` + `- Cover ONLY the subjects listed in <subChapterSubjects>\n` + `- Follow the structure defined in the training module plan\n` + `- Use only the document pages and videos provided for this specific sub-chapter\n` + `- Maintain continuity with previous sub-chapters without repeating introductory content already covered\n` + `- Start directly with the sub-chapter content\n`;
      // Append the type-specific suffix (EXPLAINER also injects the visual template brief).
      hiddenPrompt += typeConfig.buildPromptSuffix(templateHiddenPrompt);
      // Persist the resolved prompt on the subchapter so Continue via AI
      // reproduces the same generation instructions even if the per-type
      // config evolves.
      currentSubChapter.hiddenPromptGeneration = hiddenPrompt;
    }
    const ttl = new Date().getTime() + 1000 * 60; // expires in 1 minute
    const initObject = new WeetInitiator(documents, this.speachGenerated.generationOptions?.generationMode, hiddenPrompt, this.speachGenerated.generationOptions?.lang, ttl);
    initObject.auto = this.autoMode;
    // Forward the Style step choices to speacher_front (Weet editor). Persisted
    // in AISpeach.generationOptions so this also works on "Continue via AI"
    // when the AISpeach JSON is reloaded from disk.
    initObject.avatar = this.speachGenerated.generationOptions?.avatar ?? null;
    initObject.background = this.speachGenerated.generationOptions?.background ?? null;
    initObject.annotationsEnabled = this.speachGenerated.generationOptions?.annotationsEnabled ?? true;
    initObject.voice = this.speachGenerated.generationOptions?.voice ?? null;
    // Image style: EXPLAINER subchapters use the visual template's own image
    // style (so a Stickman EXPLAINER generates line-art illustrations). All
    // other types keep the global image style picked in the Style step's
    // Image Style block.
    const globalImageStyle = this.speachGenerated.generationOptions?.imageStyle ?? null;
    const templateImageStyle = getVisualTemplateByKey(tplKey)?.imageStyleValue ?? null;
    initObject.imageStyle = subChapterType === SubChapterType.EXPLAINER && templateImageStyle ? templateImageStyle : globalImageStyle;
    initObject.visualTemplate = tplKey;
    // Whitelist: per-type config overrides the dynamic getter for non-SLIDE
    // types. SLIDE falls back to the existing (mode, useAvatar) calculation.
    if (typeConfig.allowedSlideTemplates.length > 0) {
      initObject.allowedSlideTemplates = typeConfig.allowedSlideTemplates;
    } else {
      // useAvatar is the persisted on/off boolean. A coherent avatar is ALWAYS sent (gender-matched
      // to the voice), so avatar null-ness is not a reliable signal — we rely only on this boolean.
      // Absent (legacy speachs saved before the flag) => treat as "no avatar".
      const avatarOn = this.speachGenerated.generationOptions?.useAvatar ?? false;
      const generationMode = this.speachGenerated.generationOptions?.generationMode ?? null;
      initObject.allowedSlideTemplates = getAllowedSlideTemplates(avatarOn, generationMode);
    }
    // Auto video is intrinsic to the subchapter type (currently only EXPLAINER).
    initObject.autoVideoGeneration = typeConfig.autoVideo;
    localStorage.setItem(initID, LZString.compressToUTF16(JSON.stringify(initObject)));
  }
  getChapterToMap() {
    if (this.chapitreIdMap) {
      for (const lecon of this.speachToMap.lecons) {
        for (const chapitre of lecon.chapitres) {
          if (chapitre.chapitreID === this.chapitreIdMap) {
            return chapitre;
          }
        }
      }
    }
    return this.speachToMap.lecons[this.indexLecon].chapitres[this.indexChapter];
  }
  /**
   * Iterates through all keys in the local storage and removes any items
   * that have expired based on their stored ttl.
   *
   * @return {Promise<void>} A promise that resolves once the operation is complete.
   */
  async purgeExpiredWeetInitiator() {
    for (const key in localStorage) {
      const itemStored = localStorage.getItem(key);
      if (itemStored) {
        try {
          const item = JSON.parse(LZString.decompressFromUTF16(itemStored));
          const isWeetInitiator = item && typeof item === 'object' && 'documents' in item && Array.isArray(item.documents);
          // compare the expiry time of the item with the current time
          if (isWeetInitiator && (!item.ttl || new Date().getTime() > item.ttl)) {
            localStorage.removeItem(key);
          }
        } catch (e) {
          // console.debug("key = ",key,", itemStored = ",itemStored," is not a JSON object, ignoring it.")
        }
      }
    }
  }
  cleanWeetInitiatorWithDelay(initID, delay = 60000) {
    // Aligned with the WeetInitiator TTL (60s, see createAndSaveWeetInitiator).
    // Headless / cold-start contexts (speach-generator worker) need >10s to
    // bootstrap the Weet editor before it reads the entry — 10s was too short.
    setTimeout(() => {
      localStorage.removeItem(initID);
    }, delay);
  }
};
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "speachGenerated", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "speachToMap", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "indexLecon", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "indexChapter", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "weetEndpoint", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGenerator.prototype, "aiFiles", void 0);
__decorate([Prop({
  required: false,
  default: ""
})], AIChapterContentGenerator.prototype, "chapitreIdMap", void 0);
__decorate([Prop({
  default: false
})], AIChapterContentGenerator.prototype, "autoMode", void 0);
AIChapterContentGenerator = __decorate([Component({
  components: {
    WDialog,
    IconButton,
    LightButton,
    Loader,
    WInput,
    BigButton,
    StandardButton,
    Icon
  },
  emits: ['onClose']
})], AIChapterContentGenerator);
export default AIChapterContentGenerator;